import React from "react";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Switch from "react-switch";

export const AreYouOpen = ({
  displayBackButton,
  areYouOpen,
  handleChangeseating,
  backButtonClicked,
  backButtonClickedTwo,
  onClickHome,
  onClickYes,
  onClickNo,
  displayYesScreen,
}) => {
  return (
    <React.Fragment>
      <div>
        <TopTextReusableComponent
          headingText="Business Timings"
          headingParagraph="Enter the details about the timing of your Business"
        />
      </div>
      <div className="are-you-open-main">
        {displayYesScreen === false ? (
          <div>
            <div className="are-you-open-main-sectionone">
              <h5>Are you open 24x7</h5>
              <div className="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 are-you-open-main-sectionone-inside">
                <ReusableOnboardingButton
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Yes"
                  buttonType="button"
                  onClick={onClickYes}
                />
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                  buttonText="No"
                  buttonType="button"
                  onClick={onClickNo}
                />
              </div>
            </div>
            {displayBackButton === true ? null : (
              <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                <ReusableOnboardingButton
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Back"
                  buttonType="button"
                  onClick={backButtonClicked}
                />
              </div>
            )}
          </div>
        ) : (
          <div>
            <div className="are-you-open-main-sectionone">
              <div className="are-you-open-main-sectionone-toggle">
                <h6>Are you open 24x7</h6>
                <Switch
                  checked={areYouOpen}
                  onChange={handleChangeseating}
                  onColor="#59F832"
                  onHandleColor="#ffffff"
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  className="react-switch"
                  id="material-switch"
                />
              </div>
            </div>
            <div className="onboarding-map-setup-screen-autodetect-button">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                buttonType="button"
                onClick={backButtonClickedTwo}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass={
                  areYouOpen === false
                    ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                }
                disabled={areYouOpen === false ? true : false}
                buttonText="Next"
                buttonType="button"
                onClick={onClickHome}
              />
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
